/**
 * User Hooks
 *
 * React hooks for user data operations using Convex.
 */

/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return -- Convex generated types */

import { useQuery, useMutation } from 'convex/react'
import { api } from '../../convex/_generated/api'
import { logger } from '@/lib/logger'

/**
 * Hook to get user's language preference
 */
export function useLanguagePreference() {
  return useQuery(api.users.getLanguagePreference)
}

/**
 * Hook to update user's language preference
 */
export function useUpdateLanguagePreference() {
  const updateLanguage = useMutation(api.users.updateLanguagePreference)

  return async (language: string) => {
    try {
      await updateLanguage({ language })
      logger.info('Language preference updated', { language })
    } catch (error) {
      logger.error('Failed to update language preference', error instanceof Error ? error : undefined)
      throw error
    }
  }
}

/**
 * Hook to export user data
 */
export function useExportUserData() {
  return useQuery(api.users.exportUserData)
}

/**
 * Hook to delete user data
 */
export function useDeleteUserData() {
  const deleteData = useMutation(api.users.deleteUserData)

  return async () => {
    try {
      const result = await deleteData({})
      logger.info('User data deleted', { deleted: result.deleted })
      return result
    } catch (error) {
      logger.error('Failed to delete user data', error instanceof Error ? error : undefined)
      throw error
    }
  }
}

